import { MessageSquareText, ClipboardList, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const STEPS = [
  {
    icon: MessageSquareText,
    step: "1",
    title: "Request a Quote",
    desc: "Contact us by phone, email, or the online form.",
  },
  {
    icon: ClipboardList,
    step: "2",
    title: "Get Your Cleaning Plan",
    desc: "We discuss your space and cleaning needs and provide a quote.",
  },
  {
    icon: Sparkles,
    step: "3",
    title: "Let Us Make It Glow",
    desc: "Our team arrives ready to clean and leave your space fresh and sparkling.",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" className="bg-white py-20 sm:py-24" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        align="center"
        eyebrow="Easy as 1-2-3"
        title="How It Works"
      />
      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.12}>
            <div className="relative text-center md:text-left" data-testid={`step-${s.step}`}>
              <div className="flex items-center justify-center gap-4 md:justify-start">
                <span className="font-script text-6xl leading-none text-[#D4AF37]">{s.step}</span>
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#E6E6FA]">
                  <s.icon className="h-6 w-6 text-[#674EA7]" aria-hidden="true" />
                </span>
              </div>
              <h3 className="mt-6 text-xl font-medium text-[#2C2A35]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#6B6776] sm:text-base">{s.desc}</p>
              {i < 2 && (
                <div className="absolute right-0 top-8 hidden h-px w-16 bg-[#D4AF37]/40 md:block" aria-hidden="true" />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
